// EmailJS Configuration
// Sign up at https://www.emailjs.com/ (FREE - 200 emails/month)

export const EMAILJS_CONFIG = {
  PUBLIC_KEY: '1MFtf339aXswPR8J4',
  PRIVATE_KEY: 'pFJCSEsM7D8Reki_kJ6At',
  SERVICE_ID: 'service_ls0vbba',
  BONAFIDE_TEMPLATE_ID: 'template_emsswkg',
  CONSULTATION_TEMPLATE_ID: 'template_j1gstof'
};

// Email recipient
export const RECIPIENT_EMAIL = 'advimranaligarh@gmail.com';
